<ic-popup-frame
	[title]="'medication.add_medication.add_known' | translate"
	(cancelPopup)="onCancel()"
	(confirm)="onConfirm()"
>
	<form [formGroup]="form">
		<fieldset>
			<ic-search-medication-autocomplete formControlName="medication" />

			@if (form.get("quantity"); as control) {
				<div class="input-group" [class.error]="control.touched && control.errors">
					<label for="quantity">{{ "medication.found_medication_incidents.steps.details.quantity" | translate }}</label>
					<input data-test="quantity-input" formControlName="quantity" id="quantity" type="number" />
					<medication-input-error [errors]="control.errors" [touched]="control.touched" />
				</div>
			}
		</fieldset>
	</form>
</ic-popup-frame>
